var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 13.8387V5.625C15.625 4.24625 14.5037 3.125 13.125 3.125H10.5175L12.1337 1.50875L11.25 0.625L8.125 3.75L11.25 6.875L12.1337 5.99125L10.5175 4.375H13.125C13.8144 4.375 14.375 4.93625 14.375 5.625V13.8387C13.3 14.1181 12.5 15.0887 12.5 16.25C12.5 17.6287 13.6213 18.75 15 18.75C16.3787 18.75 17.5 17.6287 17.5 16.25C17.5 15.0887 16.7 14.1188 15.625 13.8387ZM15 17.5C14.3106 17.5 13.75 16.9394 13.75 16.25C13.75 15.5606 14.3106 15 15 15C15.6894 15 16.25 15.5612 16.25 16.25C16.25 16.9387 15.6894 17.5 15 17.5ZM2.5 3.75C2.5 4.91125 3.3 5.88125 4.375 6.16125V13.8387C3.3 14.1181 2.5 15.0887 2.5 16.25C2.5 17.6287 3.62125 18.75 5 18.75C6.37875 18.75 7.5 17.6287 7.5 16.25C7.5 15.0881 6.7 14.1188 5.625 13.8387V6.16125C6.7 5.88188 7.5 4.91125 7.5 3.75C7.5 2.37125 6.37875 1.25 5 1.25C3.62125 1.25 2.5 2.37125 2.5 3.75ZM6.25 16.25C6.25 16.9394 5.68937 17.5 5 17.5C4.31062 17.5 3.75 16.9394 3.75 16.25C3.75 15.5606 4.31062 15 5 15C5.68937 15 6.25 15.5612 6.25 16.25ZM6.25 3.75C6.25 4.43937 5.68937 5 5 5C4.31062 5 3.75 4.43937 3.75 3.75C3.75 3.06063 4.31062 2.5 5 2.5C5.68937 2.5 6.25 3.06063 6.25 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestsIcon);
export default __webpack_public_path__ + "static/media/requests-icon.d6ed9d3b17db8360e1b0253384a2f5a8.svg";
export { ForwardRef as ReactComponent };